<template>
  <div class="relative">
    <div
      @click="playMedia"
      class="overflow-hidden bg-bg-light rounded-times-4 cursor-pointer flex items-center justify-center"
      :class="props.auto ? 'w-full h-full' : 'w-[101px] h-[58px]'">
      <img
        class="w-times-12 h-full"
        v-if="currentType == 'audio'"
        :src="audioIcon" />
      <div
        v-if="currentType == 'video'"
        class="w-full h-full relative">
        <div class="w-full h-full absolute top-0 left-0 z-10 flex justify-center items-center bg-black bg-opacity-40">
          <iconfont
            name="icon-bofang"
            class="text-white text-20"></iconfont>
        </div>
        <video
          class="w-full h-full pointer-events-none"
          :src="src"
          :autoplay="false"></video>
      </div>

      <img
        class="w-full h-full"
        v-if="currentType == 'image'"
        :src="src" />
    </div>
    <van-dialog
      v-if="currentType == 'audio'"
      class="preview-modal"
      @close="audioCancel"
      v-model:show="visibleAudio">
      <template #title>
        <div class="w-full flex justify-between">
          <span class="font-bold">音频预览：{{ fileName }}</span>
        </div>
      </template>
      <div class="w-full h-full bg-[#f1f3f4] flex justify-center items-center">
        <audio
          :id="audioId"
          controls
          class="w-full"
          :src="src"></audio>
      </div>
    </van-dialog>
    <van-dialog
      :close-on-click-overlay="false"
      v-if="currentType == 'video'"
      class="preview-modal"
      @close="closeVideo"
      v-model:show="visibleVideo">
      <template #title>
        <div class="w-full flex justify-between">
          <span class="font-bold">视频预览：{{ fileName }}</span>
        </div>
      </template>
      <div class="w-full h-full bg-word-title flex justify-center items-center">
        <video
          v-if="visibleVideo"
          controls
          autoplay
          class="w-full h-full aspect-video"
          :src="src"></video>
      </div>
    </van-dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import { showImagePreview } from "vant";
import { fileType } from "@/static/filetype";
import audioIcon from "@/assets/images/formatter/audio.svg";

/**
 * @field {boolean} visibleVideo: 控制显示预览视频
 * @field {boolean} isPlayAudio: 控制显示预览音频
 * @field {video|image|audio} currentType: 判断当前的格式
 * @field {string} fileName: 获取当前的文件名称
 * @field {boolean} fullscreen: 是否全屏播放视频
 * @field {string} audioId: 自动生成的音频id
 *
 *
 */
const visibleVideo = ref(false);
const isPlayAudio = ref(false);
const visibleAudio = ref(false);
const currentType = ref("");
const fileName = ref();
const fullscreen = ref(false);
const audioId = "audio-" + (Math.random() * 100).toFixed(0) + "-" + (Math.random() * 100).toFixed(0);
const props = defineProps({
  src: String,
  auto: Boolean
});
const src = ref();

const pauseAudio = () => {
  isPlayAudio.value = false;
  const audioDom: AudioNode | any = document.querySelector("#" + audioId);
  if (audioDom) {
    audioDom.pause();
    isPlayAudio.value = false;
  }
};

/**
 * @function playMedia 点击预览div之后的逻辑
 */
const playMedia = () => {
  console.log("ddddddddddddzzzzzzzzzzzzzzzzzzzzzzzzzzzz");

  if (currentType.value == "image") {
    showImagePreview({ images: [src.value || ""], className: "preview-image" });
  } else if (currentType.value == "video") {
    visibleVideo.value = true;
  } else if (currentType.value == "audio") {
    visibleAudio.value = true;
    const audioDom: AudioNode | any = document.querySelector("#" + audioId);
    if (audioDom.paused) {
      audioDom.play();
      isPlayAudio.value = true;
    } else {
      audioDom.pause();
      isPlayAudio.value = false;
    }
  }
};

const closeVideo = () => {
  visibleVideo.value = false;
  console.log("dsaghdh", visibleVideo.value);
};

/**
 * @function initpage 初始化转化src，获取文件名称和文件类型
 */
const initpage = () => {
  const names: string[] | undefined = src.value?.split("/");
  if (names?.length) {
    fileName.value = names[names.length - 1];
    const suffixTotal: string[] | undefined = names[names.length - 1].split(".");
    if (suffixTotal?.length) {
      const suffix: string = suffixTotal[suffixTotal.length - 1].toLocaleLowerCase();
      if (suffix) {
        if (fileType.image.formatter.includes(suffix)) {
          currentType.value = "image";
        }
        if (fileType.video.formatter.includes(suffix)) {
          currentType.value = "video";
        }
        if (fileType.audio.formatter.includes(suffix)) {
          currentType.value = "audio";
        }
      }
    }
  }
};
const audioCancel = () => {
  pauseAudio();
};
const watchWatch = watch(
  () => props.src,
  () => {
    src.value = props.src;
    initpage();
  },
  {
    immediate: true
  }
);
initpage();
</script>

<style lang="less">
.preview-modal {
  .van-popup {
    background: transparent !important;
  }
}
</style>
